export const SET_FOOTER_STATE = "SET_FOOTER_STATE";
